import { createSlice } from "@reduxjs/toolkit";

interface OrderDetailsState {
  id: string | null;
  status: string;
}

const initialState: OrderDetailsState = {
  id: null,
  status: "",
};

export const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    setOrderId: (state, { payload }) => {
      state.id = payload;
    },
    setStatus: (state, { payload }) => {
      state.status = payload;
    },
    removeOrderDetails: () => {
      return initialState;
    },
  },
});

export const { setOrderId, setStatus, removeOrderDetails } =
  orderDetailsSlice.actions;
export default orderDetailsSlice.reducer;
